import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ErrorPage } from '../../components/common/page/ErrorPage';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

export const ServerErrorPage = ({ exception = null }) => {
    useDocumentTitle('Server Error');

    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const message = searchParams.get('message');

    if (code && message) {
        exception = {
            code,
            message
        };
    }

    return (
        <ErrorPage
            code="500"
            title="Server Error"
            exception={exception}
            description="Oops! something went wrong.">
            <div className="server-error-icon text-center">
                <span className="fa-stack fa-5x mb-3">
                    <i className="fas fa-square fa-stack-2x text-primary"></i>
                    <i
                        className="fas fa-times fa-stack-1x fa-inverse"
                        data-fa-transform="shrink-6 left-7"></i>
                    <i
                        className="fas fa-times fa-stack-1x fa-inverse"
                        data-fa-transform="shrink-6 right-7 "></i>
                    <i
                        className="fas fa-minus fa-stack-1x fa-inverse"
                        data-fa-transform="shrink-5 down-7"></i>
                    <i
                        className="fas fa-bug fa-stack-1x text-muted"
                        data-fa-transform="rotate-45 shrink-5 left-15 up-15"></i>
                    <i
                        className="fas fa-bug fa-stack-1x text-muted"
                        data-fa-transform="rotate-45 shrink-5 right-15 down-15"></i>
                </span>
            </div>
        </ErrorPage>
    );
};
